/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.2 Headphones.gltf 
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'

const Headphones = (props) => {
  const { nodes, materials } = useGLTF('./model/Headphones.gltf')
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Cushion.geometry} material={materials.Cushion} />
      <mesh geometry={nodes.Ear_Cup.geometry} material={materials['Black-1']} />
      <mesh geometry={nodes['Mid-'].geometry} material={materials['Black-2']} />
      <mesh geometry={nodes.Seprator.geometry} material={materials.Connector} />
      <mesh geometry={nodes.Seprator001.geometry} material={materials['Black-1']} />
      <mesh geometry={nodes.Cylinder025.geometry} material={materials['Black-1']} />
      <mesh geometry={nodes.Cylinder025_1.geometry} material={materials.GlowBlue} />
    </group>
  )
}

useGLTF.preload('./model/Headphones.gltf')

export default Headphones;